<div [formGroup]="dataForm" class="aside-content aside-width-3">
  <div class="aside-header fx-layout-row fx-layout-align-space-between-m fx-layout-align-center-x">
    <h3>{{ saveText }} Document</h3>
    <div class="fx-layout-row fx-gap-10">
      <button mat-raised-button (click)="save()" color="primary">{{ saveText }}</button>
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  </div>
  <concurrency-error [message]="concurrencyErrorMessage" (reloadRequested)="loadFormDetails()"></concurrency-error>
  <div>

    <div>
      <file-uploader entityType="doc" [endpointUrl]="uploadEndpoint" [singleFile]="true" fileType="2" [hideApplyAndCancelButtons]="true" (onCompleteAllEvent)="fileUploadComplete()" [compress]="false" (onQueueChanged)="fileUploadQueueChanged()">
      </file-uploader>
      @if (dataForm.errors?.fileRequired) {
        <mat-error>
          File is required for upload
        </mat-error>
      }
    </div>


    <div>
      <mat-form-field>
        <mat-label>Description</mat-label>
        <input formControlName="description" matInput>
      </mat-form-field>
      @if (description.touched && description.errors?.required) {
        <mat-error>
          Description is required
        </mat-error>
      }
      @if (description.touched && description.errors?.maxlength) {
        <mat-error>
          Description must be no more than 200 characters
        </mat-error>
      }
    </div>

    <div>
      <mat-form-field>
        <mat-label>Document Type</mat-label>
        <mat-select formControlName="documentTypeId" name="documentTypeId">
          @for (lookup of documentTypeLookupData; track lookup.id) {
            <mat-option [value]="lookup.id">
              {{ lookup.text }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (documentTypeId.touched && documentTypeId.errors?.required) {
        <mat-error>
          Document Type is required
        </mat-error>
      }
    </div>

    <div>
      <mat-form-field>
        <mat-label>Received Date</mat-label>
        <input formControlName="receivedDate" [max]="maxReceivedDate" matInput [matDatepicker]="dpReceivedDate">
        <mat-datepicker-toggle matSuffix [for]="dpReceivedDate"></mat-datepicker-toggle>
        <mat-datepicker #dpReceivedDate></mat-datepicker>
      </mat-form-field>
      @if (receivedDate.touched && receivedDate.errors?.required) {
        <mat-error>
          Received date is required
        </mat-error>
      }
    </div>
  </div>
</div>
